import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 md:py-32 bg-cream" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.76, 0, 0.24, 1]
        }} className="relative aspect-[4/5] w-full max-w-md mx-auto lg:mx-0" data-id="element-16">
            <img src="https://cdn.magicpatterns.com/uploads/vpMp6Yo89uz8Ubf9QxzvXk/mari_3_(1).jpg" alt="Mari Peixoto, founder of Oli Creative" className="w-full h-full object-cover rounded-sm grayscale hover:grayscale-0 transition-all duration-700" data-id="element-17" />
            <div className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 bg-accent text-cream p-6 md:p-8 rounded-sm shadow-xl" data-id="element-18">
              <p className="text-4xl md:text-5xl font-serif mb-1" data-id="element-19">15+</p>
              <p className="text-sm font-medium uppercase tracking-wider" data-id="element-20">
                Years Exp.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-21">
            <h2 className="text-5xl md:text-7xl font-serif tracking-tight mb-8" data-id="element-22">
              The <span className="italic text-ink-light" data-id="element-23">Designer</span>
            </h2>

            <div className="space-y-6 text-lg text-ink-light leading-relaxed" data-id="element-24">
              <p data-id="element-25">
                Hi, I'm Mari Peixoto, founder of Oli Creative. I'm a graphic
                designer with a passion for editorial layouts, crisp typography,
                and compelling visual storytelling.
              </p>
              <p data-id="element-26">
                Over the past fifteen years, I've partnered with startups,
                boutique agencies, and established brands to translate complex
                ideas into beautiful, functional design. Whether it's a 50-page
                investor deck or a minimalist business card, I believe every
                touchpoint is an opportunity to build trust and delight.
              </p>
              <p data-id="element-27">
                My approach is rooted in classic Swiss design principles—grid
                systems, negative space, and typographic hierarchy—adapted for
                modern digital and print mediums.
              </p>
            </div>

            <div className="mt-12 pt-12 border-t border-ink/10" data-id="element-28">
              <h3 className="text-sm font-medium uppercase tracking-wider text-ink mb-6" data-id="element-29">
                Toolkit & Skills
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-30">
                {['Figma', 'Adobe InDesign', 'Adobe Illustrator', 'Adobe Photoshop', 'Keynote', 'Canva', 'Google Slides', 'Typography', 'Print Production'].map(skill => <span key={skill} className="px-4 py-2 border border-ink/20 rounded-full text-sm text-ink-light" data-id="element-31">
                    {skill}
                  </span>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}